import {
  INITIATE_APPLICATION_CONTEXT,

  ADD_ASSET_SELECTION, REMOVE_ASSET_SELECTION, INVALIDATE_ASSETS_SELECTION,
  ADD_COLLECTION_SELECTION, INVALIDATE_COLLECTION_SELECTION,

  SELECT_WIDGET,

  UPDATE_ADVANCE_SETTINGS,

  GENERATING_ANONYMOUS_LINKS_SUCCEDDED, GENERATING_LINK_SUCCEDDED,

  INVALIDATE_SETTINGS,
  SET_ACTIVE_CRM,
  SET_ACTIVE_TAB,
  ACTIVATED_GMAIL_INTEGRATION

} from 'constants/actionTypes';

import { ASSETS_TABLE_WIDGET } from 'constants/widgetTypes';
import _ from 'lodash';

const initialState = {
  id: null,
  collection: null,
  assets: [],
  widget: ASSETS_TABLE_WIDGET,
  configuration: {
  },
  activeTab: null
};

function applicationReducer(state = initialState, action) {
  switch (action.type) {
    case INITIATE_APPLICATION_CONTEXT:
      return {
        ...initialState,
        ...action.payload || {}
      }
    case ADD_ASSET_SELECTION:
      var asset = action.payload;
      var assets = [...state.assets, asset];

      assets = _.uniqBy(assets, 'id');

      return {
        ...state,
        assets: assets,
        collection: null
      }

    case REMOVE_ASSET_SELECTION:
      var assets = state.assets || [];
      assets = assets.filter(item => {
        return item.id != action.payload.id;
      });

      return {
        ...state,
        assets: assets,
        collection: null
      }

    case ADD_COLLECTION_SELECTION:
      var collection = action.payload;

      return {
        ...state,
        assets: [],
        collection: collection
      };

    case INVALIDATE_COLLECTION_SELECTION:
      return {
        ...state,
        collection: null
      };


    case SELECT_WIDGET:
      return {
        ...state,
        widget: action.payload.id
      };

    case UPDATE_ADVANCE_SETTINGS:
      return {
        ...state,
        settings: action.payload
      };

    case GENERATING_ANONYMOUS_LINKS_SUCCEDDED:
      var response = action.payload;

      if (state.collection) {
        var link = response.find(item => {
          return item.entity.id === state.collection.id
        });

        if (link) {
          return {
            ...state,
            collection: {
              ...state.collection,
              link: link.url
            }
          }
        }
      } else if (state.assets) {
        var assets = state.assets.map(asset => {
          var link = response.find(item => {
            return item.entity.id === asset.id
          });

          return {
            ...asset,
            link: _.get(link, 'url')
          }
        });

        return {
          ...state,
          assets: assets
        }
      }

    case GENERATING_LINK_SUCCEDDED:
      var link = action.payload.response;
      var queryParams = state.queryParams || '';

      if (state.collection) {
        return {
          ...state,
          linkId: link.id,
          linkUrl: `${link.url}?${queryParams}`,
          collection: {
            ...state.collection,
            link: `${link.url}?${queryParams}`
          }
        }
      
      } else if (state.assets) {
        var assets = state.assets.map(asset => {
          
          return {
            ...asset,
            link: `${link.url}/a/${asset.id}?${queryParams}`
          }
        });

        return {
          ...state,
          linkId: link.id,
          linkUrl: `${link.url}?${queryParams}`,
          assets: assets
        }
      }

    case INVALIDATE_ASSETS_SELECTION:
      return{
        ...state,
        assets: []
      }

    case INVALIDATE_SETTINGS:
      return{
        ...state,
        settings: {
          expiryDate: null
        }
      }

    case SET_ACTIVE_CRM:
      return{
        ...state,
        activeCRM : action.payload
      }

    case SET_ACTIVE_TAB: 
      return {
        ...state,
        activeTab: action.payload
      }

    case ACTIVATED_GMAIL_INTEGRATION:
      return {
        ...state,
        activatedGmailIntegration: action.payload
      }

    default:
      return state
  }
}

export { applicationReducer };
